import { EventHandler, SwitchToggle } from "client/CommonComponents";
import ApprovalHierarchy from "./ApprovalHierarchy"
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRegionDropDown } from "Store/Organization/Region/RegionAction";
import { getMarketDropDown, setMarketDropDown } from "Store/Organization/Market/MarketAction";
import { getAdditionalApprovalBySuperRegion, getApprovalHierarchyBySuperRegion, getApprovalHierarchyTableExcel, getSaveApprovalHierarchy, getSaveTitle, getValidateTitle, setApprovalHierarchyBySuperRegion, setApprovalHierarchyTableExcel, setSaveApprovalHierarchy, setSaveTitle, setValidateTitle } from "Store/OrderManagement/ApprovalHierarhy/ApprovalHierarhyAction";
import permissions, { isAuthorized } from "client/utils/Permissions";
import confirmationBee from "../../../../assets/images/ConfirmationBee.svg";
import successBee from "../../../../assets/images/SuccessBee.svg";
import { base64ToArrayBuffer, popupInitialData, saveByteArray } from "utils";
import TickIcon from 'client/CommonComponents/Icons/TickIcon';
import { CONSTANTS } from "client/utils/constants";

const ApprovalHierarchyContainer = () => {

  const [showAddNewPositionPopup, setShowAddNewPositionPopup] = useState(false)
  const [showAddNewTitlePopup, setShowAddNewTitlePopup] = useState(false)
  const [showDeletePopup, setShowDeletePopup] = useState(false)
  const [regionDropDownTemp, setRegionDropDownTemp] = useState<any>([])
  const [marketDropDownTemp, setMarketDropDownTemp] = useState<any>([])
  const dispatch = useDispatch();
  const [showMarket, setShowMarket] = useState<any>(false);
  const [showTableAndButtons, setShowTableAndButtons] = useState<any>(false);
  const [selectedRegion, setSelectedRegion] = useState<any>();
  const [selectedMarket, setSelectedMarket] = useState<any>();
  const hierarchyTableTemp: any = useRef(null);
  const additionalApprovalTableTemp: any = useRef(null);
  const [showGrid, setShowGrid] = useState<any>(false);
  const [isEditHierarchy, setIsEditHierarchy] = useState<any>(false)
  const [titleValue, setTitleValue] = useState<any>('');
  const [titleError, setTitleError] = useState<any>('');
  const [selectedAddTitle, setSelectedAddtitle] = useState<any>();
  const [selectedAddPosition, setSelectedAddPosition] = useState<any>();
  const [addPositionError, setAddPositionError] = useState<any>('');
  const [addtitleError, setAddTitleError] = useState<any>('');
  const [modifiedHierarchyTable, setModifiedHierarchyTable] = useState<any>('')
  const [isEditPosition, setIsEditPosition] = useState<any>(false);
  const [isDeletePosition, setIsDeletePosition] = useState<any>(false);
  const [isHierarchyToggleChange, setIsHierarchyToggleChange] = useState<any>(false);
  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);
  const [existingRowPositionOnEdit, setExistingRowPositionOnEdit] = useState<any>(null);
  const [selectedKey, setSelectedKey] = useState("hierarchy");
  ///selectors
  const {
    regionDropDownList,
    marketDropDownList,
    approvalHierarchyBySuperRegion,
    additionalApprovalBySuperRegion,
    getUserDetails,
    isApprovalHierarchySaved,
    isValidTitle,
    isTitleSaved,
    approvalHierarchyTableExcel
  }: any = useSelector((state: any) => ({
    regionDropDownList: state.RegionDropDownReducer.regionDropDown,
    marketDropDownList: state.MarketDropDownReducer.marketDropDown,
    approvalHierarchyBySuperRegion: state.ApprovalHierarchyReducers.approvalHierarchyBySuperRegion,
    additionalApprovalBySuperRegion: state.ApprovalHierarchyReducers.additionalApprovalBySuperRegion,
    getUserDetails: state.UserProfile.getUserDetails,
    isApprovalHierarchySaved: state.ApprovalHierarchyReducers.isApprovalHierarchySaved,
    isValidTitle: state.ApprovalHierarchyReducers.isValidTitle,
    isTitleSaved: state.ApprovalHierarchyReducers.isTitleSaved,
    approvalHierarchyTableExcel: state.ApprovalHierarchyReducers.approvalHierarchyTableExcel
  }))

  useEffect(() => {
    return () => {
      setShowMarket(false)
      setShowTableAndButtons(false)
      setSelectedRegion('')
      setShowGrid(false)
      setSelectedMarket('')
      dispatch(setApprovalHierarchyBySuperRegion(null))
      dispatch(setMarketDropDown([]))
    }
  }, [])

  useEffect(() => {
    if (approvalHierarchyBySuperRegion && (selectedMarket || selectedRegion)) {
      hierarchyTableTemp.current = approvalHierarchyBySuperRegion;
      if (selectedKey === "hierarchy") {
        setShowGrid(false);
        setIsEditHierarchy(false);
        setShowTableAndButtons(true);
        setTimeout(() => setShowGrid(true));
      }
    } else if (selectedKey === "hierarchy") {
      setShowGrid(false);
      setShowTableAndButtons(false);
    }
  }, [approvalHierarchyBySuperRegion]);

  useEffect(() => {
    if (additionalApprovalBySuperRegion && (selectedMarket || selectedRegion)) {
      additionalApprovalTableTemp.current = additionalApprovalBySuperRegion;
      if (selectedKey === "additionalApprovers") {
        setShowGrid(false);
        setIsEditHierarchy(false);
        setShowTableAndButtons(true);
        setTimeout(() => setShowGrid(true));
      }
    } else if (selectedKey === "additionalApprovers") {
      setShowGrid(false);
      setShowTableAndButtons(false);
    }
  }, [additionalApprovalBySuperRegion]);

  const handleApprovalHierarchySaved = (type: string) => {
    dispatch(setSaveApprovalHierarchy(null))
    let descriptionText = '';
    if (isEditPosition) {
      descriptionText = 'Position edited successfully';
    } else if (isDeletePosition) {
      descriptionText = 'Position deleted successfully';
    } else {
      descriptionText = 'Position added successfully';
    }
    setPopupContentWithMessage(descriptionText, type);
  }

  const handleApprovalHierarchyNotSaved = (type: string) => {
    dispatch(setSaveApprovalHierarchy(null))
    let errorMessage;
    if (isEditPosition) {
      errorMessage = 'Error occured while editing the position.';
    } else if (isDeletePosition) {
      errorMessage = 'Error occured while deleting the position.';
    } else {
      errorMessage = 'Error occured while adding the position.';
    }
    setPopupContentWithMessage(errorMessage, type);
  }

  const setPopupContentWithMessage = (message: string, type: string) => {
    let decriptionTxt = (
      <div>
        <p>{message}</p>
      </div>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: type === "SUCCESS" ? successBee : confirmationBee,
      title: type,
      isDialogVisible: true,
      isCommentboxVisible: false,
      isCommentBoxRequire: false,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "Close",
      isSingleConfirmationBtn: true,
      popupOutlinebtnOnclick: () => {
        hideDialog();
        if (type === "SUCCESS") {
          if (isApprovalHierarchySaved?.isAdditionalApprover) {
            additionalApprovalTableTemp.current = modifiedHierarchyTable
          } else {
            hierarchyTableTemp.current = modifiedHierarchyTable
          }
          setModifiedHierarchyTable('')
        }
        dispatch(setSaveApprovalHierarchy(null))
        setAddPositionError('')
        setSelectedAddtitle('')
        setSelectedAddPosition('')
        setAddTitleError('')
        setTitleValue('')
        setIsDeletePosition(false)
        setIsEditPosition(false)
      },
    });
  }

  useEffect(() => {
    if (!isHierarchyToggleChange) {
      if (isApprovalHierarchySaved?.response && isApprovalHierarchySaved?.response != null) {
        handleApprovalHierarchySaved("SUCCESS");
      } else if (!isApprovalHierarchySaved?.response && isApprovalHierarchySaved?.response != null) {
        handleApprovalHierarchyNotSaved("ERROR");
      }
    } else {
      if (isApprovalHierarchySaved?.response && isApprovalHierarchySaved?.response != null) {
        if (isApprovalHierarchySaved?.isAdditionalApprover) {
          additionalApprovalTableTemp.current = modifiedHierarchyTable
        } else {
          hierarchyTableTemp.current = modifiedHierarchyTable
        }
        setModifiedHierarchyTable('')
      }
      setIsHierarchyToggleChange(false);
      dispatch(setSaveApprovalHierarchy(null))
    }
  }, [isApprovalHierarchySaved])

  useEffect(() => {
    if (approvalHierarchyTableExcel?.length) {
      const bytes = base64ToArrayBuffer(approvalHierarchyTableExcel);
      saveByteArray("ApprovalHierarchy", bytes, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      dispatch(setApprovalHierarchyTableExcel([]))
    }
  }, [approvalHierarchyTableExcel])

  const hideDialog = () => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
  }

  // Helper: update both state and ref atomically so closures always read the latest rows.
  const updateAdditionalApprovalTableData = (data: any[]) => {
    additionalApprovalTableTemp.current = data;
    updateAdditionalApprovalTableData(data);
  };

  useEffect(() => {
    if (isTitleSaved && isTitleSaved != null) {
      let decriptionTxt = (
        <div>
          <p>Title saved succesfully</p>
        </div>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: successBee,
        title: "SUCCESS",
        isDialogVisible: true,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: () => {
          hideDialog();
          dispatch(setSaveTitle(null))
          setShowAddNewTitlePopup(false)
          setTitleValue('')
        },
      });
    } else if (!isTitleSaved && isTitleSaved != null) {
      let decriptionTxt = (
        <div>
          <p>Error occured while saving the title.</p>
        </div>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: confirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: () => {
          hideDialog();
          dispatch(setSaveTitle(null))
        },
      });
    }
  }, [isTitleSaved])

  useEffect(() => {
    if (isValidTitle != null) {
      if (isValidTitle) {
        dispatch(getSaveTitle({
          titleName: titleValue?.trim(),
          savedBy: getUserDetails?.emailId
        }))
      } else if (!isValidTitle) {
        setTitleError('Title already exsist')
      }
      dispatch(setValidateTitle(null))
    }
  }, [isValidTitle])

  useEffect(() => {
    const regionDropdownTemp = regionDropDownList?.map((item: any) =>
      ({ label: item.text, key: item.value, ...item })
    );
    setRegionDropDownTemp(regionDropdownTemp);
  }, [regionDropDownList])

  useEffect(() => {
    if (marketDropDownList?.length) {
      setShowMarket(true)
      if (marketDropDownList?.length > 1) {
        const marketDropDownTemp = marketDropDownList?.map((item: any) =>
          ({ label: item.text, key: item.value, ...item })
        );
        setMarketDropDownTemp(marketDropDownTemp);
      } else {
        setShowMarket(false)
        const marketDropDownTemp = marketDropDownList?.map((item: any) =>
          ({ label: item.text, key: item.value, ...item })
        );
        setMarketDropDownTemp(marketDropDownTemp);
        const payload = {
          marketId: marketDropDownList[0]?.value,
          entityType: CONSTANTS?.LOCATION?.MARKET
        }
        dispatch(getApprovalHierarchyBySuperRegion(payload));
        dispatch(getAdditionalApprovalBySuperRegion(payload))
        setSelectedMarket({ label: marketDropDownList[0]?.text, key: marketDropDownList[0]?.value })
      }
    }
  }, [marketDropDownList])

  useEffect(() => {
    dispatch(getRegionDropDown());
  }, [])

  const handleLinkClick = (item?: any) => {
    if (item) {
      setSelectedKey(item.props.itemKey);
    }
  };

  const handleChangeEditHierarchy = () => {
    setIsEditHierarchy(!isEditHierarchy)
  }

  const handleClickAddNewPosition = () => {
    setShowAddNewPositionPopup(true)
    setIsEditPosition(false)
    setSelectedAddtitle('')
    setSelectedAddPosition('')
    setAddPositionError('')
    setAddTitleError('')
  }

  const handleClickAddNewTitle = () => {
    setTitleValue('')
    setTitleError('')
    setShowAddNewTitlePopup(true)
  }

  const validationErrorPopup = (isHierarchy: boolean = false, requestType: any = null) => {
    let decriptionTxt = (
      <div>
        <p>{!isHierarchy ? "Atleast 2 position is required." : `Atleast 2 Approver should be enabled for ${requestType}`}</p>
      </div>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: confirmationBee,
      title: "INFORMATION",
      isDialogVisible: true,
      isCommentboxVisible: false,
      isCommentBoxRequire: false,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "Close",
      isSingleConfirmationBtn: true,
      popupOutlinebtnOnclick: () => {
        hideDialog();
      },
    });
  }

  const checkHierarchy = (data: any, propertyName: any, rowData: any) => {
    const cleanPropertyName = propertyName.trim().replace(/\s+/g, '');
    let key = '';
    if (propertyName === "AFE - Fleet") {
      key = 'isAFEFleet';
    } else if (propertyName === "AFE - NonFleet") {
      key = 'isAFENonFleet';
    } else {
      key = `is${cleanPropertyName.slice(0, -1)}`;
    }
    const value = rowData[key];
    if (value === false) {
      const count = data?.filter((item: any) => item[key] === true)?.length;
      return count >= 2;
    }
    return true;
  };

  const validateRequestTypes = (data: any[], rowData: any): { isValid: boolean; requestTypes: string } => {
    const requestTypesMap: Record<string, string> = {
      isRequisition: "Requisitions",
      isDisposition: "Dispositions",
      isSendingTransfer: "Sending Transfers",
      isReceivingTransfer: "Receiving Transfers",
      isReactivation: "Reactivations",
      isAFEFleet: "AFE - Fleet",
      isAFENonFleet: "AFE - NonFleet"
    };

    const notValidRequestTypes: string[] = [];

    const filteredData = data.filter(entry => entry.stepNumber !== rowData.stepNumber);

    for (const [key, label] of Object.entries(requestTypesMap)) {
      const trueCount = filteredData.filter(entry => entry[key] === true).length;
      if (trueCount < 2) {
        notValidRequestTypes.push(label);
      }
    }

    return {
      isValid: notValidRequestTypes.length === 0,
      requestTypes: notValidRequestTypes.join(', ')
    };
  };


  const onIsRequisitionchange = (val: any, columnName: any) => {
    let approvalHierarchyBySuperRegionTemp = hierarchyTableTemp.current ? JSON.parse(JSON.stringify(hierarchyTableTemp.current)) : []
    let newHierarchyTableTemp: any = []
    let isValid = true;
    approvalHierarchyBySuperRegionTemp?.forEach((valTemp: any, index: any) => {
      if (valTemp?.stepNumber == val?.stepNumber) {
        if (columnName == 'Requisitions') {
          valTemp.isRequisition = !valTemp?.isRequisition
        } else if (columnName == 'Dispositions') {
          valTemp.isDisposition = !valTemp?.isDisposition
        } else if (columnName == 'Sending Transfers') {
          valTemp.isSendingTransfer = !valTemp?.isSendingTransfer
        } else if (columnName == 'Receiving Transfers') {
          valTemp.isReceivingTransfer = !valTemp?.isReceivingTransfer
        } else if (columnName == 'Reactivations') {
          valTemp.isReactivation = !valTemp?.isReactivation
        } else if (columnName == 'AFE - Fleet') {
          valTemp.isAFEFleet = !valTemp?.isAFEFleet
        } else if (columnName == 'AFE - NonFleet') {
          valTemp.isAFENonFleet = !valTemp?.isAFENonFleet
        }

        const isHierarchyValid = checkHierarchy(approvalHierarchyBySuperRegionTemp, columnName, valTemp);
        if (!isHierarchyValid) {
          validationErrorPopup(true, columnName);
          isValid = false;
          return;
        }

        if (!valTemp.isRequisition && !valTemp.isDisposition && !valTemp.isSendingTransfer && !valTemp.isReceivingTransfer && !valTemp.isReactivation && !valTemp.isAFEFleet && !valTemp.isAFENonFleet) {
          if (approvalHierarchyBySuperRegionTemp?.length <= 2) {
            validationErrorPopup()
            isValid = false
            return
          }
        }
        newHierarchyTableTemp.push(valTemp);
      } else {
        newHierarchyTableTemp.push(valTemp);
      }
      return valTemp;
    });
    if (isValid) {
      setModifiedHierarchyTable(newHierarchyTableTemp.slice(0, 10));
      dispatch(getSaveApprovalHierarchy({
        entityId: selectedMarket ? selectedMarket?.key : selectedRegion?.key,
        entityType: selectedMarket ? "Market" : "Region",
        hierarchySequences: newHierarchyTableTemp.slice(0, 10),
        savedBy: getUserDetails?.emailId
      }, "Updating"));
      setIsHierarchyToggleChange(true);
    }
  };

  const onClickDeleteConfirmation = (e?: any, rowData?: any) => {
    let tableTemp = hierarchyTableTemp.current ? JSON.parse(JSON.stringify(hierarchyTableTemp.current)) : []
    let newTableTemp: any = []
    tableTemp?.map((tableItem: any) => {
      if (tableItem?.stepNumber < parseInt(rowData?.stepNumber)) {
        newTableTemp.push(tableItem)
      }
      if (tableItem?.stepNumber == parseInt(rowData?.stepNumber)) {
        return
      }
      if (tableItem?.stepNumber > parseInt(rowData?.stepNumber)) {
        newTableTemp.push({
          stepNumber: tableItem?.stepNumber - 1,
          titleId: tableItem?.titleId,
          title: tableItem?.title,
          isRequisition: tableItem?.isRequisition,
          isDisposition: tableItem?.isDisposition,
          isSendingTransfer: tableItem?.isSendingTransfer,
          isReceivingTransfer: tableItem?.isReceivingTransfer,
          isReactivation: tableItem?.isReactivation,
          isAFEFleet: tableItem?.isAFEFleet,
          isAFENonFleet: tableItem?.isAFENonFleet
        });
      }
    })
    setModifiedHierarchyTable(newTableTemp.slice(0, 10))
    setShowAddNewPositionPopup(false)

    dispatch(getSaveApprovalHierarchy(
      {
        entityId: selectedMarket ? selectedMarket?.key : selectedRegion?.key,
        entityType: selectedMarket ? "Market" : "Region",
        hierarchySequences: newTableTemp.slice(0, 10),
        savedBy: getUserDetails?.emailId
      }, "Deleting"))
    setIsDeletePosition(true)
  }

  const onClickDeleteConfirmationAdditionalApprovers = (e?: any, rowData?: any) => {
    let tableTemp = additionalApprovalTableTemp.current ? JSON.parse(JSON.stringify(additionalApprovalTableTemp.current)) : []
    let newTableTemp: any = []
    tableTemp?.map((tableItem: any) => {
      if (tableItem?.stepNumber < parseInt(rowData?.stepNumber)) {
        newTableTemp.push(tableItem)
      }
      if (tableItem?.stepNumber == parseInt(rowData?.stepNumber)) {
        return
      }
      if (tableItem?.stepNumber > parseInt(rowData?.stepNumber)) {
        newTableTemp.push({
          ...tableItem,
          stepNumber: tableItem?.stepNumber - 1
        });
      }
    })
    setModifiedHierarchyTable(newTableTemp.slice(0, 10))
    setShowAddNewPositionPopup(false)

    dispatch(getSaveApprovalHierarchy({
      entityId: selectedMarket ? selectedMarket?.key : selectedRegion?.key,
      entityType: selectedMarket ? "Market" : "Region",
      hierarchySequences: newTableTemp.slice(0, 10),
      savedBy: getUserDetails?.emailId,
      isAdditionalApprover: true
    }, "Deleting"))
    setIsDeletePosition(true)
  }

  const onClickEditPosition = (e: any, rowData?: any) => {
    e.preventDefault();
    setSelectedAddtitle('')
    setIsEditPosition(true);
    setShowAddNewPositionPopup(true);
    setExistingRowPositionOnEdit(rowData?.title);
    setSelectedAddPosition({ value: rowData?.stepNumber, label: rowData?.stepNumber, key: rowData?.stepNumber })
    setSelectedAddtitle({ value: rowData?.titleId?.toString(), label: rowData?.title, key: rowData?.titleId?.toString() })
  }

  const onClickDeletePosition = (e?: any, rowData?: any) => {
    e.preventDefault();
    let tableTemp = hierarchyTableTemp.current ? JSON.parse(JSON.stringify(hierarchyTableTemp.current)) : []
    if (tableTemp?.length > 2) {
      let response = validateRequestTypes(tableTemp, rowData);
      if (!response?.isValid) {
        validationErrorPopup(true, response?.requestTypes);
        return;
      }
      setShowDeletePopup(true)
      let decriptionTxt = (
        <div>
          <p>Are you sure you want to delete this position?</p>
        </div>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: confirmationBee,
        title: "DELETE POSITION",
        isDialogVisible: true,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "NO",
        primaryBtnText: "YES",
        isSingleConfirmationBtn: false,
        popupOutlinebtnOnclick: (e?: any) => {
          hideDialog()
        },
        popupPrimarybtnOnclick: (e?: any) => {
          onClickDeleteConfirmation(e, rowData)
        }
      });
    } else {
      let decriptionTxt = (
        <div>
          <p>Atleast 2 position is required.</p>
        </div>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: confirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "OK",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: (e?: any) => {
          hideDialog();
          dispatch(setSaveApprovalHierarchy(null))
          setAddPositionError('')
          setSelectedAddtitle('')
          setSelectedAddPosition('')
          setAddTitleError('')
          setTitleValue('')
          setIsDeletePosition(false)
          setIsEditPosition(false)
        }
      });
    }
  }

  const onClickDeletePositionAdditionalApprovers = (e?: any, rowData?: any) => {
    // Use the ref so we always read the *current* rows, not the stale closure snapshot.
      const currentRows = additionalApprovalTableTemp.current;
    e.preventDefault();
    if (additionalApprovalTableTemp.current?.length == 1) {
      let decriptionTxt = (
        <div>
          <p>Atleast 1 position is required.</p>
        </div>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: confirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "OK",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: (e?: any) => {
          hideDialog();
          dispatch(setSaveApprovalHierarchy(null))
          setAddPositionError('')
          setSelectedAddtitle('')
          setSelectedAddPosition('')
          setAddTitleError('')
          setTitleValue('')
          setIsDeletePosition(false)
          setIsEditPosition(false)
        }
      });
      return
    }
    setShowDeletePopup(true)
    let decriptionTxt = (
      <div>
        <p>Are you sure you want to delete this position?</p>
      </div>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: confirmationBee,
      title: "DELETE POSITION",
      isDialogVisible: true,
      isCommentboxVisible: false,
      isCommentBoxRequire: false,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "NO",
      primaryBtnText: "YES",
      isSingleConfirmationBtn: false,
      popupOutlinebtnOnclick: (e?: any) => {
        hideDialog()
      },
      popupPrimarybtnOnclick: (e?: any) => {
        onClickDeleteConfirmationAdditionalApprovers(e, rowData)
      }
    });
  }

  const additionalApproversColumns = [
    {
      key: "stepNumber",
      title: "Approver #",
      width: 210
    },
    {
      key: "title",
      title: "Title",
      width: 210
    }
  ];
  const approvalHierarchyColumns = [
    {
      key: "stepNumber",
      title: "Approver #",
      width: 210
    },
    {
      key: "title",
      title: "Title",
      width: 210
    },
    {
      key: "isRequisition",
      title: "Requisitions",
      Cell: (row: any, e: any) => {
        return (
          isEditHierarchy ?
            <SwitchToggle checked={row?.rowData?.isRequisition} onChange={() => onIsRequisitionchange(row?.rowData, row?.column?.title)} disabled={!isEditHierarchy} className="mb-0"  data-attribute="ApprovalHierarchy_container_Default_SwitchToggle" />
            : row?.rowData?.isRequisition ? <TickIcon /> : null
        );
      },
      width: 200
    },
    {
      key: "isDisposition",
      title: "Dispositions",
      Cell: (row: any) => {
        return (
          isEditHierarchy ?
            <SwitchToggle checked={row?.rowData?.isDisposition} onChange={() => onIsRequisitionchange(row?.rowData, row?.column?.title)} disabled={!isEditHierarchy} className="mb-0"  data-attribute="ApprovalHierarchy_container_Default_SwitchToggle_2" />
            : row?.rowData?.isDisposition ? <TickIcon /> : null
        );
      },
      width: 200
    },
    {
      key: "isSendingTransfer",
      title: "Sending Transfers",
      Cell: (row: any) => {
        return (
          isEditHierarchy ?
            <SwitchToggle checked={row?.rowData?.isSendingTransfer} onChange={() => onIsRequisitionchange(row?.rowData, row?.column?.title)} disabled={!isEditHierarchy} className="mb-0"  data-attribute="ApprovalHierarchy_container_Default_SwitchToggle_3" />
            : row?.rowData?.isSendingTransfer ? <TickIcon /> : null
        );
      },
      width: 200
    },
    {
      key: "isReceivingTransfer",
      title: "Receiving Transfers",
      Cell: (row: any) => {
        return (
          isEditHierarchy ?
            <SwitchToggle checked={row?.rowData?.isReceivingTransfer} onChange={() => onIsRequisitionchange(row?.rowData, row?.column?.title)} disabled={!isEditHierarchy} className="mb-0"  data-attribute="ApprovalHierarchy_container_Default_SwitchToggle_4" />
            : row?.rowData?.isReceivingTransfer ? <TickIcon /> : null
        );
      },
      width: 200
    },
    {
      key: "isReactivation",
      title: "Reactivations",
      Cell: (row: any) => {
        return (
          isEditHierarchy ?
            <SwitchToggle checked={row?.rowData?.isReactivation} onChange={() => onIsRequisitionchange(row?.rowData, row?.column?.title)} disabled={!isEditHierarchy} className="mb-0"  data-attribute="ApprovalHierarchy_container_Default_SwitchToggle_5" />
            : row?.rowData?.isReactivation ? <TickIcon /> : null
        );
      },
      width: 200
    },
    {
      key: "isAFEFleet",
      title: "AFE - Fleet",
      Cell: (row: any) => {
        return (
          isEditHierarchy ?
            <SwitchToggle checked={row?.rowData?.isAFEFleet} onChange={() => onIsRequisitionchange(row?.rowData, row?.column?.title)} disabled={!isEditHierarchy} className="mb-0"  data-attribute="ApprovalHierarchy_container_Default_SwitchToggle_6" />
            : row?.rowData?.isAFEFleet ? <TickIcon /> : null
        );
      },
      width: 200
    },
    {
      key: "isAFENonFleet",
      title: "AFE - NonFleet",
      Cell: (row: any) => {
        return (
          isEditHierarchy ?
            <SwitchToggle checked={row?.rowData?.isAFENonFleet} onChange={() => onIsRequisitionchange(row?.rowData, row?.column?.title)} disabled={!isEditHierarchy} className="mb-0"  data-attribute="ApprovalHierarchy_container_Default_SwitchToggle_7" />
            : row?.rowData?.isAFENonFleet ? <TickIcon /> : null
        );
      },
      width: 200
    },
  ];

  const [approvalHierarchyColumnsTemp, setApprovalHierarchyColumnsTemp] = useState(approvalHierarchyColumns);
  const [additionalApproversColumnsTemp, setAdditionalApproversColumnsTemp] = useState(additionalApproversColumns);
  const actionColumnInsert = {
    key: "action",
    title: "Action",
    width: 100,
    Cell: (row: any) => {
      return (
        <>
          {permissions?.CreateEditHierarchy ? (
            <EventHandler onEvent={(e: any) => { onClickEditPosition(e, row?.rowData) }} data-attribute="ApprovalHierarchy_container_Default_EventHandler">
              <a className="me-2">Edit</a>
            </EventHandler>
          ) : null}
          {permissions?.DeleteHierarchy ? (
            <EventHandler onEvent={(e: any) => { onClickDeletePosition(e, row?.rowData) }} data-attribute="ApprovalHierarchy_container_Default_EventHandler_2">
              <a>Delete</a>
            </EventHandler>
          ) : null}
        </>
      );
    }
  }

  const actionColumnInsertforAdditionalApprovers = {
    key: "action",
    title: "Action",
    width: 100,
    Cell: (row: any) => {
      return (
        <>
          {permissions?.CreateEditHierarchy ? (
            <EventHandler onEvent={(e: any) => { onClickEditPosition(e, row?.rowData) }} data-attribute="ApprovalHierarchy_container_Default_EventHandler_3">
              <a className="me-2">Edit</a>
            </EventHandler>
          ) : null}
          {permissions?.DeleteHierarchy ? (
            <EventHandler onEvent={(e: any) => { onClickDeletePositionAdditionalApprovers(e, row?.rowData) }} data-attribute="ApprovalHierarchy_container_Default_EventHandler_4">
              <a>Delete</a>
            </EventHandler>
          ) : null}
        </>
      );
    }
  }

  useEffect(() => {
    if (approvalHierarchyBySuperRegion && additionalApprovalBySuperRegion && isAuthorized(permissions?.CreateEditHierarchy) && isEditHierarchy) {
      setShowGrid(false)
      approvalHierarchyColumns?.splice(0, 0, actionColumnInsert)
      additionalApproversColumns?.splice(0, 0, actionColumnInsertforAdditionalApprovers)
      setApprovalHierarchyColumnsTemp(approvalHierarchyColumns)
      setAdditionalApproversColumnsTemp(additionalApproversColumns)
      setTimeout(() => {
        setShowGrid(true);
      })
    } else if (approvalHierarchyBySuperRegion && additionalApprovalBySuperRegion && isAuthorized(permissions?.CreateEditHierarchy) && !isEditHierarchy) {
      setShowGrid(false)
      approvalHierarchyColumns?.slice(0)
      additionalApproversColumns?.slice(0)
      setApprovalHierarchyColumnsTemp(approvalHierarchyColumns)
      setAdditionalApproversColumnsTemp(additionalApproversColumns)
      setTimeout(() => {
        setShowGrid(true);
      })
    }
  }, [isEditHierarchy])

  const handleRegionOnChange = (value?: any) => {
    setSelectedMarket('')
    setSelectedRegion(value)
    dispatch(getMarketDropDown(value?.key))
    setIsEditHierarchy(false)
    const payload = {
      marketId: value?.key,
      entityType: CONSTANTS?.LOCATION?.REGION
    }
    dispatch(getApprovalHierarchyBySuperRegion(payload))
    dispatch(getAdditionalApprovalBySuperRegion(payload))
  }

  const handleMarketOnChange = (value?: any) => {
    setSelectedMarket(value)
    const payload = {
      marketId: value?.key,
      entityType: CONSTANTS?.LOCATION?.MARKET
    }
    dispatch(getApprovalHierarchyBySuperRegion(payload))
    dispatch(getAdditionalApprovalBySuperRegion(payload))
  }

  const validateTitle = (value: any) => {
    let valid = true
    if (value?.trim().length == 0 || value == null || value == undefined) {
      setTitleError('Please enter title')
      valid = false
    } else if (value?.length > 50) {
      setTitleError('Please enter title less than 50 characters')
      valid = false
    } else {
      setTitleError('')
    }
    return valid
  }

  const addNewTitleOnClick = (e: any) => {
    let isValidTitle = validateTitle(titleValue)
    if (isValidTitle) {
      dispatch(getValidateTitle(titleValue?.trim()))
    }
  }

  const titleOnChange = (e: any) => {
    validateTitle(e?.target?.value)
    setTitleValue(e?.target?.value)
  }

  const onExportExcel = (e: any) => {
    e.preventDefault();
    if (hierarchyTableTemp.current?.length) {
      const isAdditionalApprover = selectedKey === "additionalApprovers";
      dispatch(getApprovalHierarchyTableExcel(
        {
          entityId: selectedMarket?.key ? selectedMarket?.key : selectedRegion?.key,
          entityType: selectedMarket?.key ? CONSTANTS?.LOCATION?.MARKET : CONSTANTS?.LOCATION?.REGION
        }, isAdditionalApprover));
    }
  }

  const onAddNewTitleClick = () => {
    if (selectedAddPosition && selectedAddTitle && addPositionError?.length == 0 && addtitleError?.length == 0) {
      const isAdditionalApprover = selectedKey === "additionalApprovers";
      if (!isEditPosition) {
        let tableTemp = isAdditionalApprover ? additionalApprovalTableTemp.current : hierarchyTableTemp.current;
        let newTableTemp: any = []
        if (tableTemp?.length > 0) {
          tableTemp?.map((tableItem: any) => {
            if (tableItem?.stepNumber < parseInt(selectedAddPosition?.label)) {
              newTableTemp.push(tableItem)
            }
            if (tableItem?.stepNumber == parseInt(selectedAddPosition?.label)) {
              newTableTemp.push({
                stepNumber: tableItem?.stepNumber,
                titleId: parseInt(selectedAddTitle?.value),
                title: selectedAddTitle?.label,
                isRequisition: !isAdditionalApprover,
                isDisposition: !isAdditionalApprover,
                isSendingTransfer: !isAdditionalApprover,
                isReceivingTransfer: !isAdditionalApprover,
                isReactivation: !isAdditionalApprover,
                isAFEFleet: true,
                isAFENonFleet: !isAdditionalApprover
              })
            }
            if (tableItem?.stepNumber >= parseInt(selectedAddPosition?.label)) {
              newTableTemp.push({
                stepNumber: tableItem?.stepNumber + 1,
                titleId: tableItem?.titleId,
                title: tableItem?.title,
                isRequisition: tableItem?.isRequisition,
                isDisposition: tableItem?.isDisposition,
                isSendingTransfer: tableItem?.isSendingTransfer,
                isReceivingTransfer: tableItem?.isReceivingTransfer,
                isReactivation: tableItem?.isReactivation,
                isAFEFleet: tableItem?.isAFEFleet,
                isAFENonFleet: tableItem?.isAFENonFleet
              })
            }
            if (parseInt(selectedAddPosition?.label) > parseInt(tableTemp?.length) && tableItem?.stepNumber == parseInt(tableTemp?.length)) {
              newTableTemp.push({
                stepNumber: tableItem?.stepNumber + 1,
                titleId: parseInt(selectedAddTitle?.value),
                title: selectedAddTitle?.label,
                isRequisition: !isAdditionalApprover,
                isDisposition: !isAdditionalApprover,
                isSendingTransfer: !isAdditionalApprover,
                isReceivingTransfer: !isAdditionalApprover,
                isReactivation: !isAdditionalApprover,
                isAFEFleet: true,
                isAFENonFleet: !isAdditionalApprover
              });
            }
          });
        } else {
          newTableTemp.push({
            stepNumber: 1,
            titleId: parseInt(selectedAddTitle?.value),
            title: selectedAddTitle?.label,
            isRequisition: !isAdditionalApprover,
            isDisposition: !isAdditionalApprover,
            isSendingTransfer: !isAdditionalApprover,
            isReceivingTransfer: !isAdditionalApprover,
            isReactivation: !isAdditionalApprover,
            isAFEFleet: true,
            isAFENonFleet: !isAdditionalApprover
          });
        }
        setModifiedHierarchyTable(newTableTemp.slice(0, 10))
        setShowAddNewPositionPopup(false)

        dispatch(getSaveApprovalHierarchy(
          {
            entityId: selectedMarket ? selectedMarket?.key : selectedRegion?.key,
            entityType: selectedMarket ? "Market" : "Region",
            hierarchySequences: newTableTemp.slice(0, 10),
            savedBy: getUserDetails?.emailId,
            isAdditionalApprover: isAdditionalApprover
          }, "Saving"))
      } else {
        if (existingRowPositionOnEdit != selectedAddTitle?.label) {
          let tableTemp = []
          if (isAdditionalApprover) {
            tableTemp = additionalApprovalTableTemp.current ? JSON.parse(JSON.stringify(additionalApprovalTableTemp.current)) : []
          } else {
            tableTemp = hierarchyTableTemp.current ? JSON.parse(JSON.stringify(hierarchyTableTemp.current)) : []
          }
          let newTableTemp: any = []
          tableTemp?.map((tableItem: any) => {
            if (tableItem?.stepNumber == parseInt(selectedAddPosition?.label)) {
              newTableTemp.push({
                stepNumber: tableItem?.stepNumber,
                titleId: parseInt(selectedAddTitle?.value),
                title: selectedAddTitle?.label,
                isRequisition: !isAdditionalApprover,
                isDisposition: !isAdditionalApprover,
                isSendingTransfer: !isAdditionalApprover,
                isReceivingTransfer: !isAdditionalApprover,
                isReactivation: !isAdditionalApprover,
                isAFEFleet: true,
                isAFENonFleet: !isAdditionalApprover
              });
            } else {
              newTableTemp.push(tableItem)
            }
          })

          setModifiedHierarchyTable(newTableTemp.slice(0, 10))
          setShowAddNewPositionPopup(false)

          dispatch(getSaveApprovalHierarchy(
            {
              entityId: selectedMarket ? selectedMarket?.key : selectedRegion?.key,
              entityType: selectedMarket ? "Market" : "Region",
              hierarchySequences: newTableTemp.slice(0, 10),
              savedBy: getUserDetails?.emailId,
              isAdditionalApprover: isAdditionalApprover
            }, "Updating"))
        } else {
          closeAddAndEditPopup()
        }
      }
    } else {
      if (!selectedAddPosition) {
        setAddPositionError('Please select position.')
      }
      if (!selectedAddTitle) {
        setAddTitleError('Please select title')
      }
    }
  }

  const closeAddAndEditPopup = () => {
    setShowAddNewPositionPopup(false)
    setIsEditPosition(false)
    setExistingRowPositionOnEdit(null)
  }

  const onClearClick = () => {
    setIsEditPosition(false)
    setExistingRowPositionOnEdit(null)
    setIsDeletePosition(false)
    setSelectedAddtitle('')
    setSelectedAddPosition('')
    setAddPositionError('')
    setAddTitleError('')
    setTitleValue('')
    setShowMarket(false)
    setShowTableAndButtons(false)
    setSelectedRegion('')
    setShowGrid(false)
    setSelectedMarket('')
    setShowAddNewPositionPopup(false)
    setShowAddNewTitlePopup(false)
    dispatch(setApprovalHierarchyBySuperRegion(null))
    dispatch(setMarketDropDown([]))
    dispatch(setValidateTitle(null))
    dispatch(setSaveTitle(null))
    dispatch(setApprovalHierarchyTableExcel([]))
    dispatch(setSaveApprovalHierarchy(null))
    setMarketDropDownTemp([])
    setShowDeletePopup(false)
    setTitleError('')
    setModifiedHierarchyTable('')
    setIsHierarchyToggleChange(false)
    hierarchyTableTemp.current = null
  }

  return (
    <ApprovalHierarchy
      regionOptions={regionDropDownTemp}
      marketOptions={marketDropDownTemp}
      approvalHierarchyColumns={approvalHierarchyColumnsTemp}
      additionalApproversColumns={additionalApproversColumnsTemp}
      handleChangeEditHierarchy={handleChangeEditHierarchy}
      handleClickAddNewPosition={handleClickAddNewPosition}
      showAddNewPositionPopup={showAddNewPositionPopup}
      setShowAddNewPositionPopup={setShowAddNewPositionPopup}
      handleClickAddNewTitle={handleClickAddNewTitle}
      showAddNewTitlePopup={showAddNewTitlePopup}
      setShowAddNewTitlePopup={setShowAddNewTitlePopup}
      showMarket={showMarket}
      showTableAndButtons={showTableAndButtons}
      handleRegionOnChange={handleRegionOnChange}
      selectedRegion={selectedRegion}
      handleMarketOnChange={handleMarketOnChange}
      selectedMarket={selectedMarket}
      hierarchyTableTemp={hierarchyTableTemp}
      additionalApprovalTableTemp={additionalApprovalTableTemp}
      showGrid={showGrid}
      isEditHierarchy={isEditHierarchy}
      addNewTitleOnClick={addNewTitleOnClick}
      titleOnChange={titleOnChange}
      titleValue={titleValue}
      hideDialog={hideDialog}
      Popupcontent={Popupcontent}
      titleError={titleError}
      onExportExcel={onExportExcel}
      setSelectedAddtitle={setSelectedAddtitle}
      selectedAddTitle={selectedAddTitle}
      setSelectedAddPosition={setSelectedAddPosition}
      selectedAddPosition={selectedAddPosition}
      setAddPositionError={setAddPositionError}
      addPositionError={addPositionError}
      setAddTitleError={setAddTitleError}
      addtitleError={addtitleError}
      onAddNewTitleClick={onAddNewTitleClick}
      isEditPosition={isEditPosition}
      showDeletePopup={showDeletePopup}
      closeAddAndEditPopup={closeAddAndEditPopup}
      onClearClick={onClearClick}
      selectedKey={selectedKey}
      handleLinkClick={handleLinkClick}
    />
  )
}

export default ApprovalHierarchyContainer
